import { render } from "./BisLayout.vue?vue&type=template&id=fcf57856"
import script from "./BisLayout.vue?vue&type=script&lang=js"
export * from "./BisLayout.vue?vue&type=script&lang=js"

import "./BisLayout.vue?vue&type=style&index=0&id=fcf57856&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__